import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { IpoAlertsService, IpoTranslatePipe } from '@ip-only/front-end-library';
import { Observable, Subject } from 'rxjs';
import { FolderlinkService } from '../user/folderlink.service';
import { ResourcesService } from '../user/resources.service';

import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-project-folder-opener',
  templateUrl: './project-folder-opener.component.html',
  styleUrls: ['./project-folder-opener.component.scss'],
  providers: [IpoTranslatePipe],
  standalone: false,
})
export class ProjectFolderOpenerComponent implements OnInit, OnDestroy {
  constructor(
    private folderService: FolderlinkService,
    private alertsService: IpoAlertsService,
    private resourceService: ResourcesService,
    private translate: IpoTranslatePipe,
  ) {}

  private cancelSub$ = new Subject<void>();
  selectedProject$ = this.resourceService.getSelectedResource$();
  ifsNumber: string;
  language$: Observable<string>;

  ngOnInit() {
    this.selectedProject$.pipe(takeUntil(this.cancelSub$)).subscribe((data) => {
      if (data) {
        this.ifsNumber = data.value;
      }
    });
  }

  isButtonDisabled() {
    return !this.ifsNumber;
  }

  openFolder(projectId: string) {
    let link;

    if (projectId) {
      this.folderService
        .getFolderlink(projectId)
        .pipe(takeUntil(this.cancelSub$))
        .subscribe({
          next: (folderLink) => {
            link = folderLink.url;
            window.open(folderLink.url, '_blank');
          },
          error: (error: HttpErrorResponse) => {
            this.alertsService.addAlert({
              type: 'danger',
              message: this.handleErrorResponse(error),
            });
          },
        });
    }

    return link;
  }

  handleErrorResponse(error: HttpErrorResponse) {
    switch (error.status) {
      case 401: {
        return this.translate.transform('folderLink.401');
      }
      case 403: {
        return this.translate.transform('folderLink.403');
      }
      case 404: {
        return this.translate.transform('folderLink.404');
      }
      default: {
        return this.translate.transform('folderLink.0');
      }
    }
  }

  ngOnDestroy() {
    this.cancelSub$.next();
  }

  get isMobileScreen() {
    return window.matchMedia(`(max-width: 768px)`).matches;
  }
}
